module.exports = __webpack_public_path__ + "static/img/cabinet5_2.aabd6cd2.gif";